var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4301 12.5385C12.302 12.6321 12.151 12.6789 12 12.6789C11.8489 12.6789 11.698 12.6321 11.5699 12.5385L4.34463 7.25216C4.20455 7.14967 4.00005 7.24325 4.00005 7.40983L4 17.2744C4.00005 17.6751 4.32562 18 4.72727 18L19.2727 18C19.6744 18 20 17.6751 20 17.2744V7.40978C20 7.2432 19.7955 7.14963 19.6554 7.25211L12.4301 12.5385Z",
    fill: "#3D3C7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4084 10.6302C11.7667 10.8541 12.2334 10.8541 12.5917 10.6302L19.4137 6.36641C19.5894 6.25664 19.5065 6 19.2954 6H4.70459C4.49352 6 4.41063 6.25665 4.58626 6.36641L11.4084 10.6302Z",
    fill: "#3D3C7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.ea5a143a12dae62302a5942310f5b7ce.svg";
export { ForwardRef as ReactComponent };